import * as React from "react";
import {ShoppingBasket} from "../../models/ShoppingBasket";
import {ShoppingBasketLineItem } from "../../models/ShoppingBasketLineItem";
import {MoneyDisplay} from "../common/MoneyDisplay";
import {CartViewerLineItems} from "./CartViewerLineItems";

export interface CheckoutItemReviewProps
{
	shoppingBasket: ShoppingBasket;
	removeLineItem?: (lineItem: ShoppingBasketLineItem) => void;
	adjustLineItemQty?: (lineItem: ShoppingBasketLineItem, qty: number) => void;
	allowLineItemEdits: boolean;
}

export class CheckoutItemReview extends React.Component<CheckoutItemReviewProps, any>
{
	render()
	{
		return <div className="shoppingbasket-cartviewer col-lg-12 col-md-12 col-sm-12 col-xs-12">
			       <CartViewerLineItems shoppingBasket={this.props
		               .shoppingBasket} removeLineItem={this.props.removeLineItem} adjustLineItemQty={this.props
			               .adjustLineItemQty}
										allowLineItemEdits={this.props.allowLineItemEdits}/>
		       </div>;
	}
}


// WEBPACK FOOTER //
// ./src/components/shoppingbasket/CheckoutItemReview.tsx